// gameStorage.js
import firebase from "firebase/app";
import "firebase/firestore";

const firestore = firebase.firestore();

const OFFLINE_EVENTS_KEY = "offline_basket_events";
const GAME_STATE_KEY = "local_basket_game_state";
const GAME_ID_KEY = "gameId";
const CLOCK_TIMESTAMPS_KEY = "clock_timestamps";

export const initGame = (gameId) => {
    localStorage.setItem(GAME_ID_KEY, gameId);
};

export const saveEvent = async (event) => {
    console.log("saveEvent", event)
    const gameId = localStorage.getItem(GAME_ID_KEY);
    const enhancedEvent = {
        ...event,
        timestamp: Date.now(),
    };

    //const offline = JSON.parse(localStorage.getItem(OFFLINE_EVENTS_KEY)) || [];
    //offline.push(enhancedEvent);
    //localStorage.setItem(OFFLINE_EVENTS_KEY, JSON.stringify(offline));

    if (navigator.onLine) {
        const gameRef = firestore.collection("teamGames").doc("basketball").collection("partidos").doc(gameId);
        const eventosRef = gameRef.collection("eventos");
        await eventosRef.add(enhancedEvent);

        //const updatedOffline = offline.slice(1);
        //localStorage.setItem(OFFLINE_EVENTS_KEY, JSON.stringify(updatedOffline));
    }
};

export const syncOfflineEvents = async () => {
    const gameId = localStorage.getItem(GAME_ID_KEY);
    const offline = JSON.parse(localStorage.getItem(OFFLINE_EVENTS_KEY)) || [];

    if (navigator.onLine && offline.length > 0) {
        const batch = firestore.batch();
        const gameRef = firestore.collection("teamGames").doc("basketball").collection("partidos").doc(gameId);
        const eventosRef = gameRef.collection("eventos");

        offline.forEach((event) => {
            const newRef = eventosRef.doc();
            batch.set(newRef, event);
        });

        await batch.commit();
        localStorage.removeItem(OFFLINE_EVENTS_KEY);
    }
};

export const getGameState = () => {
    const state = localStorage.getItem(GAME_STATE_KEY);
    return state ? JSON.parse(state) : null;
};

export const setGameState = (state) => {
    localStorage.setItem(GAME_STATE_KEY, JSON.stringify(state));

    const gameId = localStorage.getItem(GAME_ID_KEY);
    if (navigator.onLine && gameId) {
        const gameRef = firestore.collection("teamGames").doc("basketball").collection("partidos").doc(gameId);
        gameRef.set({ estado: state }, { merge: true });
    }
};

export const fetchGameStateFromFirestore = async () => {
    const gameId = localStorage.getItem(GAME_ID_KEY);
    if (!gameId || !navigator.onLine) return null;

    const gameRef = firestore.collection("teamGames").doc("basketball").collection("partidos").doc(gameId);
    const doc = await gameRef.get();
    if (doc.exists && doc.data().estado) {
        const state = doc.data().estado;
        localStorage.setItem(GAME_STATE_KEY, JSON.stringify(state));
        return state;
    }
    return null;
};

export const saveClockTimestamps = ({ startTimestamp, pauseTimestamp }) => {
    const gameId = localStorage.getItem(GAME_ID_KEY);
    const data = { startTimestamp, pauseTimestamp };
    localStorage.setItem(CLOCK_TIMESTAMPS_KEY, JSON.stringify(data));

    if (navigator.onLine && gameId) {
        const gameRef = firestore.collection("teamGames").doc("basketball").collection("partidos").doc(gameId);
        gameRef.set({ reloj: data }, { merge: true });
    }
};

export const getClockTimestamps = async () => {
    const local = localStorage.getItem(CLOCK_TIMESTAMPS_KEY);
    if (local) return JSON.parse(local);

    const gameId = localStorage.getItem(GAME_ID_KEY);
    if (navigator.onLine && gameId) {
        const gameRef = firestore.collection("teamGames").doc("basketball").collection("partidos").doc(gameId);
        const doc = await gameRef.get();
        if (doc.exists && doc.data().reloj) {
            const reloj = doc.data().reloj;
            localStorage.setItem(CLOCK_TIMESTAMPS_KEY, JSON.stringify(reloj));
            return reloj;
        }
    }

    return { startTimestamp: null, pauseTimestamp: null };
};

export const calcularTiempoAcumulado = async (cuarto) => {
    const gameId = localStorage.getItem(GAME_ID_KEY);
    if (!navigator.onLine || !gameId) return 0;

    const eventosRef = firestore
        .collection("teamGames")
        .doc("basketball")
        .collection("partidos")
        .doc(gameId)
        .collection("eventos");

    const snapshot = await eventosRef
        .where("cuarto", "==", parseInt(cuarto))
        .where("tipo", "in", ["inicio_crono", "pausa_crono"])
        .orderBy("timestamp", "asc")
        .get();

    const eventos = snapshot.docs.map((d) => d.data());
    let total = 0;
    let start = null;

    for (const e of eventos) {
        if (e.tipo === "inicio_crono") {
            start = e.timestamp;
        } else if (e.tipo === "pausa_crono" && start !== null) {
            total += e.timestamp - start;
            start = null;
        }
    }

    if (start !== null) {
        total += Date.now() - start; // sigue corriendo
    }

    return Math.floor(total / 1000); // segundos
};
